$(document).ready(function () {

    var owl = $('.owl-carousel');

    $('.js-slider').owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: true,
        items: 1,
        autoplay: true,
        autoplayTimeout: 5000,
        smartSpeed: 1000,
        animateIn:'slideInRight',
        animateOut: 'slideOutLeft',
        lazyLoad: true,
        lazyLoadEager: true,
        onRefreshed: function(el){
            var items = el.item.count;
            var i = el.page.index;
            var num = i + 1;
            $(".owl-dots").append("<div class='countSlides'><span class='textDefault textDefault--f17 textDefault--cwhite'>0"+num+"</span></div>");
        },
        onInitialized:function(el){
            $(".owl-dots").append("<div class='countSlides'><span class='textDefault textDefault--f17 textDefault--cwhite'>01</span></div>");
        },
        onChanged: function(el){
            var i = el.page.index + 1;
            var items = el.item.count;
            var num = i;
            $(".owl-dots").append("<div class='countSlides'><span class='textDefault textDefault--f17 textDefault--cwhite'>0"+num+"</span></div>");
        }
    });

    $('.js-slider').on('click',function(){
        owl.trigger('next.owl');
    });

	AOS.init();

    $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({
        scrollTop: 0
      }, 1500, 'swing');
    });
    $(window).on("scroll", function () {
      var scroll = $(window).scrollTop();
      if (scroll > 700) {
        $(".js-up").addClass("visible");
      } else {
        $(".js-up").removeClass("visible");
      }
    });






  //   $('.header__rightSearch ul.nav').hide();
	//
	// $('.header__rightSearch--icon').click(function(){
	// 		$('.header__rightSearch ul.nav').slideToggle("slow");
	// });
  //
	// $('a[href^="#"]').on('click', function(event) {
	//     var target = $(this.getAttribute('href'));
	//     if( target.length ) {
	//         event.preventDefault();
	//         $('html, body').stop().animate({
	//             scrollTop: target.offset().top
	//         }, 1000);
	//     }
	// });
  //
	// $(".landingPage__image").on("click","a", function (event) {
	// 		 event.preventDefault();
	// 		 var id  = $(this).attr('href'),
	// 				 top = $(id).offset().top;
	// 		 $('body,html').animate({scrollTop: top}, 994);
	//  });
  //
  //
  // document.querySelectorAll('.mainContainer__offer-single .module').forEach(function(el, i) {
  //   el.classList.remove('module');
  //   el.classList.add('single__module');
  // });
  //
  // document.querySelectorAll('.offerSingleDetails__slider .slick-arrow').forEach(function(el, i) {
  //   el.innerHTML = '';
  // });
  //
  // $('.offerSingleDetails__slider').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   fade: true,
  //   prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
  //   nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
  //   asNavFor: '.offerSingleDetails__nav'
  // });
  // $('.offerSingleDetails__nav').slick({
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   asNavFor: '.offerSingleDetails__slider',
  //   focusOnSelect: true
  // });
  //
  // $('.modules__inner.owl-carousel').owlCarousel({
  //   items: 1,
  //   nav: false,
  //   animateOut: 'fadeOut',
  //   animateIn: true,
  //   dots: true,
  //   autoplay: true,
  //   autoplayTimeout: 5000,
  //   smartSpeed: 2000,
  //   mouseDrag: true,
  //   margin: 25,
  //   responsive: {
  //     1024: {
  //       items: 5
  //     }
  //   }
  // });
  //
  //
  // $('[data-front-slider]').slick({
  //   dots: true,
  //   infinite: true,
  //   autoplay: false,
  //   autoplaySpeed: 2000,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   speed: 1000,
  //   fade: true,
  //   useTransform: true,
  //   // cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
  //   adaptiveHeight: true,
  //   appendArrows: $('.sliderHome__nav'),
  //   prevArrow: '<button type="button" class="slick-prev"></button>',
  //   nextArrow: '<button type="button" class="slick-next"></button>'
  // });
  //
  //
  // // var wow = new WOW();
  // // wow.init();
  //
  // var didScroll = false,
  //   header = document.querySelector('.header'),
  //   body = document.querySelector('html, body'),
  //   ms = document.querySelector('body');
  //
  // function scrollTrue() {
  //   didScroll = true;
  // }
  //
  // function isOnViewPoint() {
	// 	if(header!==null){
	//     if ((body.scrollTop || ms.scrollTop) >= 100) {
	//       header.classList.add('short');
	//     } else {
	//       header.classList.remove('short');
	//     }
	// 	}
  // }
  //
  // window.addEventListener('scroll', scrollTrue);
  // document.onscroll = scrollTrue();
  //
  // setInterval(function () {
  //   if (didScroll) {
  //     didScroll = false;
  //     isOnViewPoint();
  //   }
  // });
  //

  //
  // if (document.querySelector('.rellax')) {
  //   var rellax = new Rellax('.rellax', {
  //     center: true
  //   });
  // }
  //
  // $(".sliderOwl__arrowDown").on("click", function (e) {
  //   e.preventDefault();
  //   var body = $("html, body");
  //   body.stop().animate({
  //     scrollTop: $('.intro').offset().top - 100
  //   }, 1500, 'swing');
  // });
  //
  // $('#arrowMap').on('click', function() {
  //   var body = $("html, body");
  //   body.stop().animate({
  //     scrollTop: $('.contactPlaceMap').offset().top - 200
  //   }, 1500, 'swing');
  // });
  //
	// var hash= window.location.hash
	//       var target = $(hash);
	//       headerHeight = 120;
	// 			if (target.length) {
	// 				console.log(target.length);
	//         $('html,body').stop().animate({
	//           scrollTop: target.offset().top - 125 //offsets for fixed header
	//         }, 'linear');
	//       }


});

$(window).scroll(function(){
    if ($(window).scrollTop() > 0){
        $('.mainContainer__content--projectInfo .contentBlock').addClass('sidebarMenu--scrolled');

    } else {
        if ($(window).width()>1240){
            $('.mainContainer__content--projectInfo .contentBlock').removeClass('sidebarMenu--scrolled');

        }

    }
});

if ($(window).width()<1240){
    $('.mainContainer__content--projectInfo .contentBlock').addClass('contentBlock--scrolled');
} else {
    $('.mainContainer__content--projectInfo .contentBlock').removeClass('contentBlock--scrolled');
}
